
export const companyListSGroups=[
    'company_read',
    'company_read_projects',
        'project_read',
];
